/* eslint-disable space-before-function-paren */
/*
 * @Author: MWeiLiu
 * @Date: 2020-8-7 15点16分
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2020-8-7 15点16分
 */

const state = {
  demandSquareList: []
}

const actions = {
  set_demandSquareList(context, option) {
    context.commit('set_demandSquareList', option)
  }
}

const getters = {}

const mutations = {
  set_demandSquareList(state, option) {
    if (!state.demandSquareList[option.columnid] || option.data.length === 0) {
      state.demandSquareList[option.columnid] = []
    }
    state.demandSquareList[option.columnid].push(...option.data)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/circle/demandSquareList.js